<script setup>
import { computed } from 'vue';
import { 
	getClasseValeur } from '@/scripts/global.js';

const { valeur } = defineProps({
    valeur: Object
});

const classe = computed(() => {
    return getClasseValeur(valeur);
});

const couleur = computed(() => {
    if (classe.value) {
        return `var(--couleur-${classe.value})`;
    } else {
        return null;
    }
});

function getInfobulle(classe) {
    switch(classe) {
        case 'valeur-saisie-prise-en-compte':
        case 'valeur-saisie-a-prendre-en-compte':
            return 'Valeur modifiée';
        case 'valeur-a-recalculer':
            return 'Valeur à calculer ou recalculer';
        case 'valeur-recalcul-identique':
            return 'Valeur recalculée identique à la valeur précédente';
        case 'valeur-recalcul-different':
            return 'Valeur recalculée';
        case 'valeur-forcee':
            return 'Valeur forcée';
        case 'valeur-manquante':
            return 'Valeur manquante pour un calcul aval';
        case 'valeur-entree-en-erreur':
            return 'Valeur non calculable car donnée d\'entrée en erreur';
        case 'valeur-en-erreur':
            return 'Formule ou expression en erreur';
    }
}

</script>

<template>
    <div class="pastille" 
    v-if="classe"
    v-tooltip="getInfobulle(classe)">
        <svg width="20" height="20">
            <polygon points="20,0 10,0 20,10" :fill="couleur" stroke="var(--couleur-bordure)"/>
        </svg>
    </div>
</template>

<style scoped>

.pastille {
    position: absolute;
    padding: 0px;
    top: 0px;
    right: 0px;
}

</style>